// ------------------------------------
// Constants
// ------------------------------------
export const UPDATE_CONTENT = 'UPDATE_CONTENT'

// ------------------------------------
// Actions
// ------------------------------------
export function updateContent (value = {}) {
  return {
    type    : UPDATE_CONTENT,
    payload : value
  }
}

export const actions = { updateContent }

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [UPDATE_CONTENT] : (state, action) => action.payload
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = { type: 'homepage', items: [], title: '' }
export default function contentReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/content.js